/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `bags_liners` - Bags & liners
* `food_drink_containers` - Food & drink containers
* `paper_foils_films_labels_stickers` - Paper, foils, films, labels, stickers
* `napkins_cutlery_stirrers_straws` - Napkins, cutlery, stirrers, straws
* `storage_transportation` - Storage & transportation
* `non_packaging_items` - Non-packaging items
 */
export type CCFPackagingGroupCategoryEnum = typeof CCFPackagingGroupCategoryEnum[keyof typeof CCFPackagingGroupCategoryEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CCFPackagingGroupCategoryEnum = {
  bags_liners: 'bags_liners',
  food_drink_containers: 'food_drink_containers',
  paper_foils_films_labels_stickers: 'paper_foils_films_labels_stickers',
  napkins_cutlery_stirrers_straws: 'napkins_cutlery_stirrers_straws',
  storage_transportation: 'storage_transportation',
  non_packaging_items: 'non_packaging_items',
} as const;
